import styled from 'styled-components'

export const StyledLogoAndLanguage = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	& > img {
		max-width: 33%;
	}
`;